export const facturacion = {
    text1: "Sposób płatności",
    text2: "Karta kredytowa",
    text3: "Brak zapisanych sposobów płatności",
    text4: "Edytuj sposób płatności",
    text5: "Dodaj sposób płatności",
    text6: "Dodaj sposób płatności",
    text7: "Zaktualizuj sposób płatności",
    text8: "Zapisz lub zaktualizuj sposób płatności, z którego będą pobierane opłaty miesięczne.",
    text9: "Numer karty:",
    text10: "Ważna do",
    text11: "CVC",
    text12: "Zapisz kartę",
    text13: "Nieprawidłowy numer",
    text14: "Nieprawidłowe",
    text15: "Nieprawidłowy kod CVC.",
    text16: "Coś poszło nie tak",
    text17: "Zużycie",
    text18: "Wystawione faktury",
    text19: "Od - Do",
    text20: "ID",
    text21: "Kwota",
    text22: "Podmiot wystawiający fakturę",
    text23: "BIG NERDS COMPANY L.L.C.",
    text24: "Data wystawienia",
    text25: "Status",
    text26: "Pobierz fakturę",
    text27: "Generowanie faktury ...",
    text28: "Już prawie gotowe, prosimy o chwilę cierpliwości...",
    text29: "Wczytywanie ...",
    text30: "Niestety nie udało się wygenerować faktury",
    text31: "Czy na pewno usunąć ten sposób płatności?",
    text32: "Zapisane dane zostaną utracone",
    text33: "Usuń sposób płatności",
    text34: "Anuluj",

    // Corrections
    p1: "Subskrypcja",
    p2: "Twoja subskrypcja",
    p3: "BEZPŁATNY",
    p4: "NA ZAMÓWIENIE",
    p5: "Nie masz aktywnej subskrypcji. Zróbmy z tym porządek!",
    p6: "Wygasa:",
    p7: "Wybierz plan",
    p8: "Podnieś plan",
    p9: "Liczba obiektów",
    p10: "Za obiekt",
    p11: "Zarządzaj subskrypcją",
    p12: "Ustawienia płatności",
    p13: "Wygasa:",
    p14: "Edytuj",
    p15: "Automatyczne odnawianie",
    p16: "Włączone",
    p17: "Kolejna płatność zaplanowana jest na",
    p18: "Faktury i rachunki",
    p19: "NA ZAMÓWIENIE",
    p20: "Zobacz fakturę",
    p21: "Pobierz fakturę",
    p22: "za",

    p23: "Miesięcznie",
    p24: "Rocznie",
    p25: "Dajemy Ci 2 miesiące w prezencie.",
    p26: "Rodzaj subskrypcji",


    p27: "Apartament turystyczny",
    p28: "Hotel - hostel",
    p29: "Kemping",
    p30: "Willa",


    p31: `"<strong>Obiekt</strong>" oznacza pojedynczy dom lub apartament. W przypadku "<strong>aparthotelu</strong>" każdy apartament liczy się jako osobny obiekt`,
    p32: `Liczą się
    <strong>pokoje</strong> w przypadku hoteli, łóżka w przypadku hosteli
    oraz <strong>osoby </strong> w przypadku kempingów.

    <br />
    <strong>Na przykład:</strong> hostel z 4 pokojami i 20 łóżkami liczy się jako
    20 jednostek noclegowych`,

    p33: `PREMIUM`,
    p34: `miesiąc`,
    p35: `pokój`,
    p36: `apartament`,
    p37: `Szczegóły planu`,
    p38: `Check-in na miejscu przez QR`,
    p39: `Check-in przez link wysłany wcześniej`,
    p40: `Powitalna wiadomość e-mail`,
    p41: `Biometryczny podpis regulaminu`,
    p42: `Skaner dowodu i paszportu`,
    p43: `Nieograniczone miejsce w chmurze`,
    p44: `Sklep ze sprzedażą krzyżową`,
    p45: `Automatyczne przesyłanie raportów do służb`,
    p46: `Synchronizacja rezerwacji z PSM`,
    p47: `Zaktualizuj subskrypcję`,
    p48: `Dalej`,
    p49: `za`,

    p50: `Wybierz dodatkowe usługi do swojego planu`,
    p51: `Polecane`,
    p52: `WhatsApp`,
    p53: `Zapraszamy Twoich gości do check-inu przez WhatsApp z wyprzedzeniem, zanim dotrą do obiektu.`,
    p54: `apartament`,
    p55: `willa`,
    p56: `miejsce`,
    p57: `pokój`,
    p58: `Różnica w korzystaniu z WhatsApp`,
    p59: `Korzystanie z naszego WhatsApp`,
    p60: `Przy korzystaniu z naszej usługi WhatsApp nadawcą wiadomości wysyłanych do gości będzie WACheckin. Zajmujemy się obsługą wiadomości, aby zapewnić skuteczną komunikację z gośćmi.`,
    p61: `Jeśli korzysta Pan/Pani z naszej usługi na własnym numerze WhatsApp, nadawcą będzie Pana/Pani nazwa na WhatsApp i można mieć własną odznakę weryfikacji. Koszt wysyłki zależy wtedy od zużycia w WhatsApp Business u Meta.`,
    p62: `Korzystanie z własnego WhatsApp Business`,
    p63: `Oceny`,
    p64: `Warto skorzystać z okazji, aby poprawić doświadczenie gości i zebrać więcej pozytywnych opinii!`,
    p65: `Korzyści`,
    p66: `Po check-oucie wyślemy gościom ankietę oceniającą przez WhatsApp, co wyraźnie podniesie reputację obiektu w sieci. Nasza usługa jest pomyślana tak, aby zwiększać liczbę pozytywnych opinii.`,
    p67: `Dostęp zdalny`,
    p68: `Wysyłamy gościom wirtualny klucz, aby mogli samodzielnie wejść do obiektu.`,
    p69: `Korzyści`,
    p70: `Goście otrzymają kody dostępu do pokoju bezpiecznie i wygodnie zaraz po zakończeniu check-inu, co daje im komfort i usprawnia zarządzanie dostępem.`,
    p71: `Weryfikacja tożsamości`,
    p72: `Weryfikujemy tożsamość gości za pomocą naszego oprogramowania do porównania biometrycznego.`,
    p73: `Korzyści`,
    p74: `Weryfikujemy tożsamość gości za pomocą naszego oprogramowania do porównania biometrycznego, upewniając się, że dokumenty należą do osoby, która wchodzi do obiektu.`,
    p75: `Wykup subskrypcję`,
    p76: `Nieograniczone miejsce w chmurze`,
    p77: `Na zamówienie`,
    p78: `Zapytaj nasz dział sprzedaży`,
    p79: `WhatsApp`,
    p80: `Weryfikacja tożsamości`,
    p81: `Opinie (oceny check-inu)`,
    p82: `Połączenie z API inteligentnych zamków`,
    p83: `Obciążanie karty (kaucje, usługi itp.)`,
    p84: `Skontaktuj się ze sprzedażą`,
    p85: ``,
    p86: ``,
    p87: ``,
    p88: ``,
    p89: ``,






};
